import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'
import Media from 'sb-media'

import { Image, UpchargePrice } from 'components/_new/ui'
import { Button, buttonMessages } from 'components/_new/controls'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './WelcomeBackModal.scss'


class WelcomeBackModal extends PureComponent {

  static propTypes = {
    data: PropTypes.shape({
      item: PropTypes.shape({
        image: PropTypes.string.isRequired,
        upchargePrice: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }

  static defaultProps = {
    name: constants.modals.premiumProducts.WelcomeBack,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, data: { item: { image, upchargePrice = 1000 } = {} } } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
        titleUppercase
      >
        <FormattedMessage className={s.subTitle} tag="div" {...messages.subTitle} />
        <FormattedMessage className={s.text} tag="div" {...messages.text} />
        <div className={s.imageContainer}>
          <UpchargePrice className={s.priceLabel} price={upchargePrice} size="lg" />
          <Media mobile>
            {
              (isMobile) => (
                <Image className={s.image} src={image} h={isMobile ? 200 : 300} x2 />
              )
            }
          </Media>
        </div>
        <FormattedMessage className={s.hint} tag="div" {...messages.hint} />
        <ModalFooter>
          <Button
            className={s.button}
            title={buttonMessages.gotIt}
            color="brand"
            size="md"
            dataTestId="gotItButton"
            onClick={this.close}
          />
        </ModalFooter>
      </Modal>
    )
  }
}


export default WelcomeBackModal
